import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {RouteUtil} from "../../../util/route.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {AddOrUpdateUserOptions} from "../dialog/add-or-update-user/options/add-or-update-user.options";
import {AddOrUpdateUserComponent} from "../dialog/add-or-update-user/add-or-update-user.component";

@Component({
  selector: 'app-users',
  standalone: false,
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive', 'Business'];
  displayDataSources = ['edit', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive', 'BusinessId'];
  displayColumnTypes = ['event', 'string', 'string', 'string', 'string', 'string', 'boolean', 'business'];
  displayEndPoint = [this.ServicePath.UPDATE_USERS, '', '', '', '', '', '', ''];
  users: any = [];
  userType: string = 'STAFF';
  allFilters = FilterUtil.UsersFilters;
  filters: any = {};
  protected readonly RouteUtil = RouteUtil;

  constructor(injector: Injector) {
    super(injector);
    if (location.pathname.endsWith(`${RouteUtil.DASHBOARD_MODULE}/${RouteUtil.STAFFS_COMPONENT}`)) {
      this.userType = 'STAFF';
    } else {
      this.userType = 'CLIENT';
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.userType === 'STAFF') {
      this.displayedColumns = ['Update', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive', 'Business'];
      this.displayDataSources = ['edit', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive', 'BusinessId'];
      this.displayColumnTypes = ['event', 'string', 'string', 'string', 'string', 'string', 'boolean', 'business'];
      this.displayEndPoint = [this.ServicePath.UPDATE_USERS, '', '', '', '', '', '', ''];
    } else {
      this.displayedColumns = ['ClientsClub', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive'];
      this.displayDataSources = ['info', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email', 'IsActive'];
      this.displayColumnTypes = ['event', 'string', 'string', 'string', 'string', 'string', 'boolean'];
      this.displayEndPoint = ['', '', '', '', '', '', ''];
    }
  }

  override loadOnline() {
    super.loadOnline();
    if (!this.filters.Values) {
      this.filters.Values = [];
    }
    this.filters.Values.push({
      Field: 'UserType',
      Type: 'EQ',
      Value: this.userType
    });
    this.serviceApi.getUsers(this.tableProperties.offset, this.tableProperties.limit, undefined, undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.users = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.users) {
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].info = (index: number) => {
          this.onInfoClicked(index);
        };
        this.users[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.users[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateUserOptions = new AddOrUpdateUserOptions();
    addOrUpdateUserOptions.user = {};
    addOrUpdateUserOptions.userType = this.userType;
    addOrUpdateUserOptions.onInsertOrUpdateFinished = (user: any) => {
      if (this.userType === 'CLIENT') {
        this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.USER_DETAIL_COMPONENT, {
          UserId: user.UserId
        }]).then();
      }
    };
    let addOrUpdateUserComponent = this.matDialog.open(AddOrUpdateUserComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateUserComponent.componentInstance.addOrUpdateUserOptions = addOrUpdateUserOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateUserOptions = new AddOrUpdateUserOptions();
    addOrUpdateUserOptions.user = this.users[index];
    addOrUpdateUserOptions.userType = this.userType;
    addOrUpdateUserOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateUserComponent = this.matDialog.open(AddOrUpdateUserComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateUserComponent.componentInstance.addOrUpdateUserOptions = addOrUpdateUserOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteUsers(this.users[index].UserId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onInfoClicked(index: number) {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.USER_DETAIL_COMPONENT, {
      UserId: this.users[index].UserId
    }]).then();
  }
}
